<template>
  <v-row>
    <v-dialog max-width="550" v-model="this.component.dialog_cl1" persistent>
      <v-card class="mx-auto" outlined>
        <v-container>
          <v-row>
            <v-card-title> Pesquisar Clientes </v-card-title>
            <v-spacer></v-spacer>
            <v-icon
              class="mr-2 mb-6"
              @click="
                () => {
                  close();
                }
              "
              >mdi-close</v-icon
            >
          </v-row>
          <v-switch
            color="primary"
            label="Pessoa Jurídica"
            v-model="isFormalPeople"
          ></v-switch>
          <v-text-field
            outlined
            v-model="search"
            label="Pesquisar"
            append-icon="mdi-magnify"
            @keyup.enter="searchClient()"
          ></v-text-field>
          <v-data-table
            v-if="!isMobile"
            :headers="atual.header"
            :items="atual.getter"
            no-data-text="Sem registros"
            hide-default-footer
            no-results-text="Nenhum cliente encontrado"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, -1],
              'items-per-page-text': 'Items por página',
            }"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon
                color="green darken-3"
                class="ml-3"
                @click="add_client(item)"
                >mdi-plus-circle</v-icon
              >
            </template>
          </v-data-table>

          <v-list v-else class="mobile-list">
            <template v-for="(item, index) in atual.getter">
              <v-list-item :key="item.id" class="mobile-list-item">
                <v-list-item-content class="py-2">
                  <v-list-item-title class="item-name">
                    {{ isFormalPeople ? item.legalpeople && item.legalpeople.socialName : item.physicalpeople && item.physicalpeople.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="item-code">Cód: {{ item.id }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn depressed small color="green darken-3" dark class="action-btn" @click="add_client(item)">
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="`d-${index}`" />
            </template>
            <v-list-item v-if="!atual.getter || atual.getter.length === 0">
              <v-list-item-content>
                <v-list-item-title class="text-center grey--text">Sem registros</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-pagination
            v-model="current"
            :length="lastPage"
            color="success"
            :total-visible="10"
          ></v-pagination>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { headers } from "./script";
import { GET_ALL_CLIENT, GET_AUTOCOMPLETE_CLIENT } from "../../../../store/actions/client";
import { mapGetters } from "vuex";
export default {
  props: { component: Object() },
  data: () => ({
    search: String(),
    lastPage: Number(),
    current: Number(),
    isFormalPeople: Boolean(),
    pagIsLegal: Boolean(),
    atual: {
      header: Array(),
      getter: Array(),
    },
    headers,
    enterprise: Object(),
    isInitialized: false,
  }),
  methods: {
    isLegal(isLegal = false) {
      const type = { isPhisical: "isPhisical", isLegal: "isLegal" };
      this.atual.header = this.headers[
        isLegal ? type.isLegal : type.isPhisical
      ];

      this.atual.getter = isLegal
        ? this.getLegalClients
        : this.getPhysicalClients;

      this.atualTotal = isLegal ? this.pagLegalTotal : this.pagPhysicalTotal;
      this.atualCurrent = isLegal
        ? this.pagLegalCurrent
        : this.pagPhysicalCurrent;
    },
    close() {
      this.component.dialog_cl1 = !this.component.dialog_cl1;
    },
    add_client(item) {
      this.component.refreshClient(item);
      this.close();
    },
    async GetPhysical(page = 1) {
      await this.$store.dispatch(GET_ALL_CLIENT, {
        page: page,
        limit: 10,
        type_people: "PhysicalPeople",
        paginate: true
      });
    },
    async GetLegal(page = 1) {
      await this.$store.dispatch(GET_ALL_CLIENT, {
        page: page,
        limit: 10,
        type_people: "LegalPeople",
        paginate: true
      });
    },
    async searchClient() {
      if(this.search.length >= 2) {
        if(this.isFormalPeople) {
          this.AutocompleteClientLegal(this.search);
        } else {
          this.AutocompleteClientPhysical(this.search);
        }
      }
    },
    async AutocompleteClientPhysical(searchVal) {
        await this.$store.dispatch(GET_AUTOCOMPLETE_CLIENT, {
          type_people: "PhysicalPeople",
          page: 1,
          limit: 10,
          paginate: true,
          enterprise_id: this.enterprise.id,
          search: searchVal,
        });
    },
    async AutocompleteClientLegal(searchVal) {
        await this.$store.dispatch(GET_AUTOCOMPLETE_CLIENT, {
          type_people: "LegalPeople",
          enterprise_id: this.enterprise.id,
          search: searchVal,
          page: 1,
          limit: 10,
          paginate: true,
        });
    },
  },
  computed: {
    ...mapGetters([
      "getPhysicalClients",
      "getLegalClients",
      "getPaginationClient",
      "getEnterprises",
    ]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    getPaginationClient: function (val) {
      this.current = val.current_page;
      this.lastPage = val.last_page;
    },



    getPhysicalClients: function () {
    },
    getLegalClients: function () {
    },
    current: function (val) {
      if (this.pagIsLegal) {
        this.GetLegal(val);
      } else {
        this.GetPhysical(val);
      }
    },
    isFormalPeople: function (val) {
      this.pagIsLegal = val;
      if (this.isInitialized) {
        if (val) {
          this.GetLegal();
        } else {
          this.GetPhysical();
        }
      }
      this.isLegal(val);
    },
    search: function (val) {
      if(val.length == 0) {
        if(this.isFormalPeople) {
          this.GetLegal();
        } else {
          this.GetPhysical();
        }
      }
    },
    'component.dialog_cl1': function(isOpen) {
      if (isOpen && !this.isInitialized) {
        this.isInitialized = true;
        this.GetPhysical();
      }
    }
  },
  async created() {
    this.enterprise = this.getEnterprises.data[0]
  },
  mounted() {
    this.isLegal();
  },
};
</script>

<style scoped>
.mobile-list {
  overflow-y: auto;
  max-height: 50vh;
  padding: 0;
}

.mobile-list-item {
  min-height: 52px;
}

.item-name {
  font-size: 13px !important;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-code {
  font-size: 11px !important;
}

.action-btn {
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
}
</style>
